__turbopack_context__.v({
  "crumbsContent": "styles-module__Gv5DAa__crumbsContent",
  "crumbsItem": "styles-module__Gv5DAa__crumbsItem",
  "link": "styles-module__Gv5DAa__link",
});
